export default function (params) {
  return params.substr(0, 3) + '*****' + params.substr(8)
}



// WEBPACK FOOTER //
// ./src/config/modifyPhone.js